/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 21:52:34
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare തുറക്കുക",
    name2: "ഒരു റിസർവേഷൻ നടത്തുക",
    name3: "Carlcare ഉപയോഗിച്ച്, നിങ്ങൾക്ക് എപ്പോൾ വേണമെങ്കിലും ഓർഡർ പരിശോധിക്കാൻ കഴിയും.",
    name4: "",
    name5: "വലത്തേക്ക് സ്ലൈഡ് ചെയ്യുക",
    name6: "പരിശോധിച്ചുറപ്പിക്കൽ പൂർത്തിയായി",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "ഉപകരണത്തിന്റെ മോഡൽ തിരഞ്ഞെടുക്കുക",
    name2: "തകരാറിന്റെ വിവരണം:",
    name3: "സർവീസ് സ്റ്റോർ തിരഞ്ഞെടുക്കാൻ ടാപ്പ് ചെയ്യുക",
    name4: "സേവന സ്റ്റോർ:",
    name5: "റിസർവേഷൻ സമയം:",
    name6: "നിങ്ങളുടെ ഉപകരണത്തിന്റെ പ്രശ്‌നം വിശദമായി വിവരിക്കുക!",
    name7: "എത്തിച്ചേരുന്ന സമയം തിരഞ്ഞെടുക്കാൻ ടാപ്പ് ചെയ്യുക",
    name8: "നിങ്ങളുടെ ശരിയായ കോൺ‌ടാക്റ്റ് വിശദാംശങ്ങൾ‌ നൽ‌കുന്നതിലൂടെ ഞങ്ങൾ‌ക്ക് നിങ്ങളെ ബന്ധപ്പെടാൻ‌ കഴിയും",
    name9: "ലഭ്യമായ റിസർവേഷൻ സമയം ഇനിപ്പറയുന്നതാണ്",
    name10: "നിങ്ങളുടെ ഫോൺ നമ്പർ നൽകുക",
    name11: "വില",
    name12: "വ്യക്തിപരമായ വിവരം:",
    name13: "നിങ്ങളുടെ പേര് നൽകുക",
    name14: "സമർപ്പിക്കുക",
    name15: "നിർത്തുക",
    name16: "ശരി",
  },
  shops: {
    name1: "നിങ്ങൾ തിരഞ്ഞെടുത്ത ബ്രാൻഡിനെ അടിസ്ഥാനമാക്കി, ഇനിപ്പറയുന്ന സ്റ്റോറുകൾക്ക് നിങ്ങൾക്ക് സേവനം നൽകാൻ കഴിയും!",
    name2: "ഉടൻ കൂടുതൽ റീട്ടെയിൽ സ്റ്റോറുകളിൽ വരുന്നു! ഞങ്ങൾക്കൊപ്പം നിൽക്കൂ!",
  },
  price: {
    name1: "ബ്രാൻഡ്",
    name2: "മോഡൽ",
    name3: "ഇനം",
    name4: "വില",
    name5: "വിനീതമായ ഓർമ്മപ്പെടുത്തൽ:",
    name6: "ഈ വിലകൾ റഫറൻസിനുള്ളതാണ്, യഥാർത്ഥ വില നിങ്ങളുടെ ഉപകരണ അവസ്ഥയ്ക്ക് വിധേയമാണ്.",
    name7: "പ്രത്യേക ചിഹ്നം ഇല്ലെങ്കിൽ, വില യൂണിറ്റ് പ്രാദേശിക കറൻസി യൂണിറ്റാണ്.",
    name8: "ക്ഷമിക്കണം! നിലവിലെ പ്രദേശത്ത് വില വിവരങ്ങളൊന്നും ലഭ്യമല്ല.",
    name11:"ലേബർ തുക",
    name12:"ആകെ വില",
    name13: "5. ലേബർ തുക \"/\" ആണെങ്കിൽ, അതിന് അർത്ഥം ലേബർ തുക സ്റ്റോറുമായി കൂടിയാലോചിക്കേണ്ടതുണ്ട് എന്നാണ്.",
    item_main_board: "മെയിൻബോർഡ്",
    item_screen_frame: "സ്ക്രീൻ (ഫ്രെയിം)",
    item_screen_screen_frame: "സെക്കൻഡറി സ്‌ക്രീൻ (ഫ്രെയിം)",
    item_touch_screen: "ടച്ച് സ്‌ക്രീൻ",
    item_camera: "ക്യാമറ",
    item_fixed_focus_camera: "ഫിക്സഡ് ഫോക്കസ് ക്യാമറ",
    item_auto_focus_camera: "ഓട്ടോ ഫോക്കസ് ക്യാമറ",
    item_screen: "സ്‌ക്രീൻ",
    item_secondary_screen: "സെക്കൻഡറി സ്‌ക്രീൻ",
    item_fingerprint_module: "വിരലടയാള മൊഡ്യൂൾ",
    item_speaker: "സ്പീക്കർ",
    item_receiver: "സ്വീകർത്താവ്",
    item_small_board: "ചെറിയ ബോർഡ്",
    item_battery_cover: "ബാറ്ററി കവർ",
    item_battery: "ബാറ്ററി",
    item_charger: "ചാർജർ",
    item_usb_cable: "USB കേബിൾ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ഡാറ്റ ഇല്ല",
    name2: "സേവനദാതാവ്:",
    name3: "സേവന ബ്രാൻഡ്:",
    name4: "ടെലിഫോൺ:",
    name5: "ഓർഡറിന്റെ അളവ്:",
    name6: "സേവന റേറ്റിംഗ്",
    name7: "സേവന പരിസ്ഥിതി:",
    name8: "സേവന മനോഭാവം:",
    name9: "സേവന കാര്യക്ഷമത:",
    name10: "സേവന ഗുണനിലവാരം:",
    name11: "ഉപഭോക്തൃ വിലയിരുത്തൽ",
    name12:"ഇതുവരെ",
    name13:"അടച്ചു",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare തുറക്കുക",
    name1: "മുൻ‌ഗണനാ സേവനം ആക്സസ് ചെയ്യുന്നതിന് ദയവായി റിസർവേഷൻ വിവരം സ്ക്രീൻഷോട്ട് ചെയ്ത് രസീത് ആയി സേവ് ചെയ്യുക.",
    name2: "വിജയകരമായി സമർപ്പിച്ചു",
    name3: "1. ഡാറ്റ ക്ലീനപ്പ് ചെയ്യുക",
    name4: "നിങ്ങളുടെ ഫോണിലെ പ്രധാനപ്പെട്ട സ്വകാര്യ ഡാറ്റ മുൻ‌കൂട്ടി ബാക്കപ്പ് ചെയ്യുക",
    name5: "2. പവർ ഓൺ പാസ്‌വേഡ് അപ്രാപ്തമാക്കുക",
    name6: "സേവന സ്റ്റോറിലേക്ക് പോകുന്നതിനുമുമ്പ്, ദയവായി:",
    name7: "സേവന സ്റ്റോർ:",
    name8: "റിസർവേഷൻ സമയം:",
    name9: "തകരാറിന്റെ വിവരണം:",
    name10: "ഉപകരണ മോഡൽ:",
    name11: "ഓർഡർ നമ്പർ:",
    name12: "ഓർഡർ വിവരം",
  },
  title: {
    
    name1: "ഇനിപ്പറയുന്ന രാജ്യങ്ങളെ പിന്തുണയ്ക്കുന്നു:",
    name2: "മോഡൽ തിരഞ്ഞെടുക്കുക",
    name3: "റിസർവേഷൻ",
    name4: "സർവീസ് സ്റ്റോർ വിശദാംശങ്ങൾ",
    name5: "സർവീസ് സ്റ്റോർ തിരഞ്ഞെടുക്കുക",
  },
  error: {
    
    name1: "ഡാറ്റാ ഇല്ല. നിങ്ങളുടെ റിപ്പയർ വിവരം പരിശോധിക്കുക",
    name2: "കൂടുതൽ സഹായം ആവശ്യമുണ്ടോ? ഞങ്ങളെ ബന്ധപ്പെടുക.",
    name3: "ക്ഷമിക്കണം, നിലവിലെ പ്രദേശത്ത് Carlcare കേന്ദ്രങ്ങളൊന്നുമില്ല.",
    name4: "ആദ്യം ഒരു സേവന കേന്ദ്രം തിരഞ്ഞെടുക്കുക",
    name5: "പരാജയപ്പെട്ടു",
    name6: "ആദ്യം ഉപകരണ മോഡൽ തിരഞ്ഞെടുക്കുക",
    name7: "വിശദാംശങ്ങൾ",
    name8: "നിങ്ങളുടെ ആവശ്യങ്ങൾ വിശദമായി വിവരിക്കുക",
    name9: "",
  },
  add1:{
    "name0": "ml",
    "name1": "നിങ്ങളുടെ ഓർഡർ സ്ഥിരീകരിച്ചു. നിങ്ങളുടെ വരവിനായി ഞങ്ങൾ കാത്തിരിക്കുന്നു.",
    "name2": "നഗരം തിരഞ്ഞെടുക്കുക",
    "name3": "%1$s അക്കങ്ങളുള്ള ഒരു ഫോൺ നമ്പർ ഇൻപുട്ട് ചെയ്യുക.",
    "name4": "പ്രവൃത്തിദിന സമയം",
    "name5": "തിങ്കളാഴ്ച",
    "name6": "ചൊവ്വാഴ്ച",
    "name7": "ബുധനാഴ്ച",
    "name8": "വ്യാഴാഴ്ച",
    "name9": "വെള്ളിയാഴ്ച",
    "name10": "ശനിയാഴ്ച",
    "name11": "ഞായറാഴ്ച",
    "name12": "രാജ്യം എന്റർ ചെയ്\u200cത് തിരയുക"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "മറ്റുള്ളവ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"റീഡയറക്ട് ചെയ്യാൻ ടാപ്പ് ചെയ്യുക",
    name3:"ഓർഡർ റേറ്റ് ചെയ്യാൻ Carlcare ആപ്പ് തുറക്കുക",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"സേവനം തിരഞ്ഞെടുക്കുക",
    name7:"സൗജന്യ വൃത്തിയാക്കൽ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "തെറ്റായ വിവരം",
    "cancelReason1": "സമയത്ത് എത്തിച്ചേരാൻ കഴിയില്ല",
    "cancelReason2": "ഡ്യൂപ്ലിക്കേറ്റ് ഓർഡർ/എന്റെ ഓർഡറല്ല",
    "cancelReason3": "പരാജയം ആവർത്തിക്കില്ല",
    "cancelReason4": "ടെസ്റ്റിന്/അന്വേഷണത്തിന്/ഇവന്റിന് മാത്രം…",
    "cancelReason5": "ഉയർന്ന വില",
    "cancelReason6": "മെറ്റീരിയൽ ക്ഷാമം",
    "cancelReason7": "വേർതിരിച്ചിട്ടില്ലാത്ത സേവനങ്ങൾ ഒന്നുമില്ല",
    "cancelReason8": "കട വളരെ ദൂരെയാണ്",
    "cancelReason9": "കട അടച്ചിരിക്കുന്നു",
    "cancelReason10": "മോശം സേവന മനോഭാവം",
    "cancelReason11": "മറ്റ് ബ്രാൻഡുകൾക്കുള്ള റീപ്ലേസ്മെന്റ്/റിപ്പെയർ",
    "cancelReason12": "സ്റ്റോർ കണ്ടെത്താൻ കഴിഞ്ഞില്ല",
    "cancelReason13": "മറ്റുള്ളവർ",
    "cancelOrder": "ഓർഡർ റദ്ദാക്കുക",
    "reason_dialog_title": "റദ്ദാക്കാനുള്ള കാരണം ദയവായി ഞങ്ങളോട് പറയുക",
    "Cancel": "നിർത്തുക",
    "OK": "ശരി",
    "name1": "Enter verification code",
    "name2": "പരിശോധിച്ചുറപ്പിക്കൽ കോഡ് അസാധുവാണ്",
    "repair_reservation_detail_canceled": "ഈ ഓർഡർ റദ്ദാക്കി!",
    "purchase_cancel_dialog_content": "ഓർഡർ റദ്ദാക്കാൻ നിങ്ങൾ സ്ഥിരീകരിക്കുന്നുണ്ടോ?",
    "yes": "അതെ",
    "no": "മായ"
}
};
